<template>
  <div class="multi-search">
    <Select v-model="domain" class="multi-search-item" placeholder="企业名称" @on-change="getTable">
      <Option v-for="item in domainList" :value="item.value" :key="item.value">{{ item.label }}</Option>
    </Select>
    <Select v-model="table" class="multi-search-item" placeholder="工作表名称" @on-change="updateTable">
      <Option v-for="item in tableList" :value="item.value" :key="item.value">{{ item.label }}</Option>
    </Select>
    <Select v-model="rule" class="multi-search-item" placeholder="规则名称" @on-change="updateRule">
      <Option v-for="item in ruleList" :value="item.value" :key="item.value">{{ item.label }}</Option>
    </Select>
  </div>
</template>
<script>
export default {
  data() {
    return {
      domain: '',
      domainList: [],
      table: '',
      tableList: [],
      rule: '',
      ruleList: []
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    // 初始化
    init() {
      this.domain = ''
      this.domainList = []
      this.table = ''
      this.tableList = []
      this.rule = ''
      this.ruleList = []
      this.getDomain()
    },
    // 获取列表 - 企业
    getDomain() {
      setTimeout(() => {
        this.domainList = [{ value: '1', label: '企业1' }, { value: '2', label: '企业2' }]
      }, 200)
    },
    // 获取列表 - 工作表
    getTable() {
      if (this.domain !== undefined && this.domain !== '') {
        setTimeout(() => {
          this.tableList = [{ value: '1', label: '工作表1' }, { value: '2', label: '工作表2' }]
        }, 200)
      }
    },
    // 获取列表 - 规则
    getRule() {
      if (this.domain !== undefined && this.domain !== '' && this.table !== undefined && this.table !== '') {
        setTimeout(() => {
          this.ruleList = [{ value: '1', label: '规则1' }, { value: '2', label: '规则2' }]
        }, 200)
      }
    },
    updateTable() {
      this.$emit('updateTable', this.table)
      this.getRule()
    },
    // 更换规则，更新表格
    updateRule() {
      this.$emit('updateRule', this.rule)
    }
  }
}
</script>
<style lang="scss" scoped="">
  .multi-search-item {
    width: 210px;
    margin-left: 20px;
  }
</style>
